<template>
    <div class="p-grid">
        <div class="p-col-12">
            <div class="card">
                <Toast />
                <h5>{{ $t('menu.shopOnlineCD') }}</h5>
                <div class="p-grid">
                    <div class="p-col-12 p-md-2">
                        <span class="p-float-label">
                            <Calendar ref="startDateCalendar" style="width: 100%" dateFormat="dd.mm.yy" :showTime="true" hourFormat="24" :showIcon="true" :showButtonBar="true" v-model="startDateModel"></Calendar>
                            <label>{{ $t('sportsbets.startDate') }}</label>
                        </span>
                    </div>
                    <div class="p-col-12 p-md-2">
                        <span class="p-float-label">
                            <Calendar style="width: 100%" dateFormat="dd.mm.yy" :showTime="true" hourFormat="24" :showIcon="true" :showButtonBar="true" v-model="endDateModel"></Calendar>
                            <label>{{ $t('sportsbets.endDate') }}</label>
                        </span>
                    </div>
                    <div class="p-col-6 p-md-8 p-text-right"><Button type="button" :loading="isReportLoading" :label="$t('buttons.show')" class="p-button-raised p-button-success" @click="showReport()" /></div>
                    <transition-group name="p-message" tag="div" class="p-col-12">
                        <Message :key="errorKeyCount" :severity="'error'" v-show="showError">{{ $t('alerts.generalError') }}</Message>
                    </transition-group>
                </div>
                <div class="card" v-if="showReportData">
                    <DataTable :value="reportData" ref="datatable" responsiveLayout="scroll">
                        <template #header>
                            <div class="p-grid">
                                <div class="p-input-icon-left p-col-12 p-md-2">
                                    <i class="pi pi-search" />
                                    <InputText  v-model="searchTerm" :placeholder="$t('search.byName')" style="width: 100%" />
                                </div>
                            </div>
                        </template>
                        <Column>
                            <template #body="slotProps">
                                <span class="indexColumn">{{ slotProps.index + 1 }}</span>
                            </template>
                        </Column>
                        <Column :header="$t('system.shop')" field="ShopName" :sortable="true">
                            <template #body="{ data }">
                                <Button v-if="hasAccess(availableMenus, 'shopOnlineTransactions')" :label="data.ShopName" class="p-button-text p-button-plain p-mr-2 p-mb-2" @click="goto('shopOnlineTransactions', { shopId: data.ShopId })" />
                                <span v-else>{{ data.franchise }}</span>
                            </template>
                        </Column>
                        <Column field="ShopOnlineCreditAmount" :header="$t('transactions.ShopCreditAmount')" :sortable="true">
                            <template #body="slotProps">{{ formatCurrency(slotProps.data.ShopOnlineCreditAmount) }} </template>
                        </Column>  
                        <Column field="ShopOnlineDebitAmount" :header="$t('transactions.ShopDebitAmount')" :sortable="true">
                            <template #body="slotProps">{{ formatCurrency(slotProps.data.ShopOnlineDebitAmount) }} </template>
                        </Column> 
                    </DataTable>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { BoReportsApi } from '../../../service/BoReportsApi';
import { BoApi } from '../../../service/BoApi';
export default {
    name: 'onlineShopCD',
    data() {
        return {
            dbReportData: [],
            BoApi: new BoApi(),
            BoReportsApi: new BoReportsApi(),
            isReportLoading: false,
            showReportData: false,
            startDateModel: null,
            endDateModel: null,
            errorKeyCount: 0,
            showError: false,
            crtRoute: 'shopOnlineCD',
            searchTerm: '',
        };
    },
    mounted() {
        let crtDate = new Date();
        let year = crtDate.getFullYear();
        let month = crtDate.getMonth() + 1;
        if (month <= 9) {
            month = '0' + month;
        }
        let day = crtDate.getDate();
        if (day <= 9) {
            day = '0' + day;
        }
        var startDateString = year + '-' + month + '-' + day + 'T00:00';
        var endDateString = year + '-' + month + '-' + day + 'T23:59';
        this.startDateModel = new Date(startDateString);
        this.endDateModel = new Date(endDateString);
        this.showReport();
    },
    computed: {
        availableMenus() {
            return this.$store.getters['user/availableMenus'];
        },
        reportData(){
            return this.dbReportData.filter(item => item.ShopName.toLocaleLowerCase().includes(this.searchTerm.toLocaleLowerCase()) )
        }
    },
    methods: {
        showReport() {
            this.showReportData = false;
            this.isReportLoading = true;
            this.BoReportsApi.getShopOnlineCD(this.formatEnDateAndTime(this.startDateModel), 
                                            this.formatEnDateAndTime(this.endDateModel))
                .then((reportResponse) => {
                    if (reportResponse.data != null) {
                        this.dbReportData = reportResponse.data;
                        this.tableKey++;
                    }
                    this.isReportLoading = false;
                    this.showReportData = true;
                })
                .catch((error) => {
                    this.checkForUnauthorizedError(error);
                    this.showError = true;
                    this.errorKeyCount++;
                    this.isReportLoading = false;
                });
        },
    },
};
</script>